import { useGetHttp } from "../../http.hook";

interface IResponse {
    url: string;
}

export function useDownloadCsvUploadDataAdminHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/favourite-socials/csv/:csvId/download",
  });
}
